let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9;
import styled from 'styled-components';
import { FloatingOverlay } from '@floating-ui/react';
import { IconButton } from '@ovpn-ui/core';
import { colors, media } from '@ovpn-ui/styles';
import Box from '../Box';
import { LayerIndex } from '../_internal/constants';
export const Overlay = styled(FloatingOverlay)(_t || (_t = _`
    z-index: ${0};

    background: rgba(52, 64, 84, 0.5);

    backdrop-filter: blur(8px);
`), LayerIndex.Modal);
export const Container = styled(Box)(_t2 || (_t2 = _`
    position: fixed;
    bottom: 50%;
    left: 50%;
    z-index: ${0};

    display: flex;
    flex-direction: column;
    gap: 16px;

    width: 100%;

    background-color: ${0};
    border-radius: 8px;

    transform: translate(-50%, 50%);

    ${0}
`), LayerIndex.Modal, colors.neutralWhite, media.XS(_t3 || (_t3 = _`
        bottom: 80px;
        left: 50%;

        width: calc(100% - 32px);
        transform: translateX(-50%);
    `)));
export const Header = styled.div(_t4 || (_t4 = _`
    position: relative;

    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: flex-end;

    padding: 16px 24px 0;

    &[data-empty='true'] {
        justify-content: space-between;
    }
`));
export const CloseButton = styled(IconButton)(_t5 || (_t5 = _`
    color: ${0};
`), colors.neutralTextSection);
export const DescriptionContainer = styled.div(_t6 || (_t6 = _`
    margin-top: -20px;

    padding: 0 24px;
`));
export const Content = styled.div(_t7 || (_t7 = _`
    display: flex;
    flex-direction: column;

    margin: -4px 0;
    padding: 24px;

    overflow-y: auto;

    background: linear-gradient(white, rgba(255, 255, 255, 0.1)),
        linear-gradient(rgba(255, 255, 255, 0.1), white) 0 100%,
        linear-gradient(to bottom, rgba(64, 73, 104, 0.15), rgba(64, 73, 104, 0)),
        linear-gradient(to top, rgba(64, 73, 104, 0.15), rgba(64, 73, 104, 0)) 0 100%;
    background-color: white;
    background-repeat: no-repeat;
    background-size: 100% 96px, 100% 96px, 100% 32px, 100% 32px;
    background-attachment: local, local, scroll, scroll;
`));
export const Footer = styled.div(_t8 || (_t8 = _`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    width: 100%;

    padding: 16px 24px;

    ${0}
`), media.XS(_t9 || (_t9 = _`
        flex-direction: column;
        justify-content: center;
    `)));